import { apiClient } from './apiClient';

const storageKey = (type) => `submasters:${type}`;

export const getItems = async (type) => {
  try {
    const res = await apiClient.get(`/api/v1/submasters/${type}`);
    return res.data?.data || res.data || [];
  } catch (e) {
    // fallback to localStorage
    const raw = localStorage.getItem(storageKey(type));
    return raw ? JSON.parse(raw) : [];
  }
};

export const createItem = async (type, payload) => {
  try {
    const res = await apiClient.post(`/api/v1/submasters/${type}`, payload);
    return res.data;
  } catch (e) {
    // If unauthorized, surface helpful message in console for debugging
    if (e?.response?.status === 401) {
      console.warn('CreateItem: 401 Unauthorized - user may not be authenticated or CSRF cookie missing');
    }
    // fallback: persist locally
    const current = await getItems(type);
    const item = { id: Date.now(), name: payload.name, active: payload.active, related_items: payload.related_items || [] };
    const next = [item, ...current];
    localStorage.setItem(storageKey(type), JSON.stringify(next));
    return item;
  }
};

export const deleteItem = async (type, id) => {
  try {
    const res = await apiClient.delete(`/api/v1/submasters/${type}/${id}`);
    return res.data;
  } catch (e) {
    const current = await getItems(type);
    const next = current.filter((it) => String(it.id) !== String(id));
    localStorage.setItem(storageKey(type), JSON.stringify(next));
    return { success: true };
  }
};

export const toggleActive = async (type, id, active) => {
  try {
    const res = await apiClient.patch(`/api/v1/submasters/${type}/${id}`, { active });
    return res.data;
  } catch (e) {
    const current = await getItems(type);
    const next = current.map((it) => (String(it.id) === String(id) ? { ...it, active } : it));
    localStorage.setItem(storageKey(type), JSON.stringify(next));
    return { success: true };
  }
};

export const updateItem = async (type, id, payload) => {
  try {
    const res = await apiClient.patch(`/api/v1/submasters/${type}/${id}`, payload);
    return res.data;
  } catch (e) {
    const current = await getItems(type);
    const next = current.map((it) => (String(it.id) === String(id) ? { ...it, ...payload } : it));
    localStorage.setItem(storageKey(type), JSON.stringify(next));
    return { success: true, item: next.find((it) => String(it.id) === String(id)) };
  }
};
